<template>
  <section>
    <gs-header :title="`Yêu cầu thanh toán: ${clientName}`">
    </gs-header>
    <gs-table
      :ref="requestPaymentTable"
      :table-name="requestPaymentTable"
      data-source="request-payments"
      :data-params="filters"
      :data-sorted="sorted"
      :data-sorts="sorts"
      @remove-filter="removeFilter"
      >
      <section slot="filters">

      </section>
      <template slot-scope="datas">
        <el-table
          :data="datas.data"
          border
          style="width: 100%">
        >
          <el-table-column
              label="#"
              width="80"
            >
              <template slot-scope="scope">
                <small v-if="dataPaginations[requestPaymentTable]">{{(scope.$index + 1) + ((dataPaginations[requestPaymentTable].current_page -1) * dataPaginations[requestPaymentTable].per_page)}}</small>
              </template>
            </el-table-column>

          <el-table-column
            label="Tên"
            width="200"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.client">{{scope.row.client.data.name}}</p>
            </template>
          </el-table-column>

          <el-table-column
            label="Số tiền"
          >
            <template slot-scope="scope">
              <p class="text-red text-right">{{scope.row.money | vnd}} </p>
            </template>
          </el-table-column>

          <el-table-column
            label="Ngày tạo"
          >
            <template slot-scope="scope">
              <p>{{scope.row.created_at}}</p>
            </template>
          </el-table-column>

          <el-table-column
            label="Trạng thái"
            width="200"
          >
            <template slot-scope="scope">
              <p :class="{'text-green': scope.row.status}">{{scope.row.status_txt}}</p>
            </template>
          </el-table-column>

          <el-table-column
            label="Ghi chú"
            width="200"
          >
            <template slot-scope="scope">
              <p>{{scope.row.note}}</p>
            </template>
          </el-table-column>

          <el-table-column
            label="Ngân hàng"
            width="200"
          >
            <template slot-scope="scope">
              <p>{{scope.row.bank_info}}</p>
            </template>
          </el-table-column>


          <el-table-column
            width="95"
          >
            <template slot-scope="scope">
              <section class="padding-sm-top padding-sm-bottom">
                <el-tooltip v-if="!scope.row.status" placement="top" content="Duyệt thanh toán" class="display-inline">
                   <a @click.prevent="confirmPayment(scope.row)" class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa-check"></i></a>
                </el-tooltip>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </gs-table>
  </section>
</template>

<script>
import { debounce } from 'lodash'
import ls from 'local-storage'
import { confirmRequestPayment } from 'src/api/affiliates'
export default {

  name: 'RequestPayment',

  data () {
    return {
      requestPaymentTable: 'request-payments',
      filters: {
        sort: 'created_at:-1',
        include: 'client'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        {key: 'created_at', name: 'Ngày tạo'}
      ],
      clientName: ''
    }
  },
  methods: {
    removeFilter () {
      this.reloadGsTable(this.requestPaymentTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.requestPaymentTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.requestPaymentTable)
      }
    }, 300),
    confirmPayment (payment) {
      this.$confirm(`Bạn chắc chắn muốn xác nhận yêu cầu thanh toán này?`, 'Xác nhận yêu cầu thanh toán', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        if (payment.id) {
          confirmRequestPayment(payment.id).then(response => {
            if (response.code === 200) {
              this.$message({
                type: 'success',
                message: 'Xác nhận yêu cầu thanh toán thành công'
              })
              this.reloadGsTable(this.requestPaymentTable)
            } else {
              this.$message({
                type: 'danger',
                message: 'Xác nhận yêu cầu thanh toán thất bại'
              })
            }
          })
        }
      }).catch(() => {

      })
    }
  },
  mounted () {
    this.filters.client_id = this.$route.params.id
    this.clientName = this.$route.query.name
    if (ls.get('filters') && ls.get('filters')[this.requestPaymentTable]) {
      this.filters = ls.get('filters')[this.requestPaymentTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.requestPaymentTable)
  },
  beforeRouteEnter (to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['affiliates']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// RequestPayment.vue?35fc1dae